export type ProfileComponentResources = {
    [K in 'formLabel' |
    'formLabelDescription' |
    'profileText' |
    'profileTextDescription' |
    'fullNameLabel' |
    'fullNamePlaceHolder' |
    'fullNameRequiredErrMsg' |
    'fullNameMinCharactersErrMsg' |
    'fullNameMaxCharactersErrMsg' |
    'fullNameOnlySpacesErrMsg' |
    'invalidFullNameErrMsg' |
    'dobLabel' |
    'mobileNumberLabel' |
    'mobileNumberPlaceHolder' |
    'mobileNumberRequiredErrMsg' |
    'mobileNumberInvalidPatternErrMsg' |
    'emailAddressLabel' |
    'emailAddressPlaceHolder' |
    'emailAddressRequiredErrMsg' |
    'emailAddressInvalidPatternErrMsg' |
    'motherTongueLabel' |
    'preferredLanguageLabel' |
    'motherTonguePlaceHolder' |
    'addressLabel' |
    'addressLabelPlaceHolder' |
    'addressMinCharactersRequired' |
    'addressMaxCharactersRequired' |
    'addressOnlySpacesErrMsg' |
    'saveBtnLabel' |
    'deleteAccountBtnLabel' |
    'genderLabel' |
    'genderPlaceHolder' |
    'dobFutureDateErrMsg' |
    'dobUnrealisticDateErrMsg' |
    'dobUnderageErrMsg' |
    'invalidDateErrMsg'
    ]: string;
};

// Default values for the resources
export const DefaultProfileComponentResource: ProfileComponentResources = {
    formLabel: 'My Profile',
    formLabelDescription: 'Manage your personal information and account settings',
    profileText: 'Personal Information',
    profileTextDescription: 'Update your personal details and profile picture',
    fullNameLabel: 'Full Name',
    fullNamePlaceHolder: 'Enter your full name',
    fullNameRequiredErrMsg: 'Full Name is required.',
    fullNameMinCharactersErrMsg: 'A minimum of 2 characters are required.',
    fullNameMaxCharactersErrMsg: 'Maximum 50 characters allowed.',
    fullNameOnlySpacesErrMsg: 'Full Name cannot contain only spaces.',
    invalidFullNameErrMsg: 'Invalid Full Name.',
    dobLabel: 'Date Of Birth',
    invalidDateErrMsg: 'Please enter a valid date.',
    mobileNumberLabel: 'Mobile Number',
    mobileNumberPlaceHolder: 'Enter your mobile number',
    mobileNumberRequiredErrMsg: 'Mobile Number is required',
    mobileNumberInvalidPatternErrMsg: 'Invalid Mobile Number',
    emailAddressLabel: 'Email',
    emailAddressPlaceHolder: 'Enter your email',
    emailAddressRequiredErrMsg: 'Email address is required',
    emailAddressInvalidPatternErrMsg: 'Invalid Email Address',
    motherTongueLabel: 'Language You Speak',
    preferredLanguageLabel: 'Preferred Translation Language',
    motherTonguePlaceHolder: 'Enter Language You Speak',
    addressLabel: 'My Address',
    addressLabelPlaceHolder: 'Enter your address',
    addressMinCharactersRequired: 'A minimum of 3 characters are required',
    addressMaxCharactersRequired: 'Maximum 250 characters allowed',
    addressOnlySpacesErrMsg: 'Address cannot contain only spaces.',

    saveBtnLabel: 'Save',
    deleteAccountBtnLabel: 'Delete Account',
    genderLabel: 'Gender',
    genderPlaceHolder: 'Select Gender',
    dobUnrealisticDateErrMsg: 'Unrealistic Date Entered',
    dobFutureDateErrMsg: 'Future Date Not Allowed',
    dobUnderageErrMsg: 'Age must be 18 or above'
};


// Gender Enumerations
export const GenderEnum = Object.freeze({
    MALE: { value: "Male", textValue: "Male" },
    FEMALE: { value: "Female", textValue: "Female" },
    PREFER_NOT_TO_SAY: { value: "Prefer Not To Say", textValue: "PreferNotToSay" }
});
